import React, {useMemo} from 'react';
import cn from 'classnames';

import {ModuleLinks} from '../Common';

import {IImageVideoText} from './IImageVideoText';

import styles from './ImageVideoText.module.scss';

const ImageVideoText = ({links, backgroundColor, title, description, media, classNames}: IImageVideoText) => {
	const {contentBackground, textColor} = useMemo(
		() =>
			backgroundColor === 'grey'
				? {contentBackground: '#E7E7E7', textColor: ''}
				: {contentBackground: '#000000', textColor: '#FFFFFF'},
		[backgroundColor],
	);
	const contentStyle = {
		'--content-background-color': contentBackground,
	} as React.CSSProperties;

	return (
		<div className={cn(styles['module-image-video-text'], classNames)}>
			<div className={styles['module-image-video-text__content']} style={contentStyle}>
				{media && <div className={styles['module-image-video-text__media']}>{media}</div>}
				<div className={styles['module-image-video-text__content-wrapper']}>
					<div className={styles['module-image-video-text__text-wrapper']}>
						{title && (
							<div style={{color: textColor}} className={styles['module-image-video-text__title']}>
								{title}
							</div>
						)}
						{description && (
							<div style={{color: textColor}} className={styles['module-image-video-text__description']}>
								{description}
							</div>
						)}
					</div>
					{links.length > 0 && (
						<ModuleLinks className={styles['module-image-video-text__cta-wrapper']}>{links}</ModuleLinks>
					)}
				</div>
			</div>
		</div>
	);
};

export default ImageVideoText;
